import styled from "styled-components/macro";

export const FileUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 472px;
  width: 100%;
  padding: 16px;

  .upload-button-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 8px;
    margin-top: 4px;

    button {
      padding: 10px 20px;
    }
  }

  label {
    color: var(--Neutral-60);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.18px;
  }

  .error-message {
    color: var(--chart-color-01);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-top: 4px;
  }
`;

export const FileUploadBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px;
  border-radius: 12px;
  border: 1.5px dashed
    ${(props) => (props.isDragging ? "var(--Neutral-100)" : "var(--Neutral-8)")};

  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border: 1.5px dashed var(--Neutral-100);
    background: var(--Neutral-4);
  }

  &.error-txt {
    border: 1.5px dashed var(--chart-color-01);
  }

  .upload-icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  .upload-text {
    color: var(--Neutral-80);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.14px;

    .browse-text {
      text-decoration: underline;
    }

    .or-text {
      font-weight: 400;
    }
  }

  .file-info {
    color: var(--Neutral-40);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.12px;
  }

  &.file-preview {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var(--Neutral-80);
    border-style: solid;
    background: var(--Success-8);
    cursor: default;
    padding: 10px;
    min-height: auto;

    &:hover {
      border-color: var(--Neutral-40);
      background: var(--Success-8);
    }

    .file-details {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;

      .file-icon {
        min-width: 40px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        background: var(--Neutral-20);
        overflow: hidden;

        .custom-file-icon {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.5px;
          overflow: hidden; /* important */
        }

        /* Curved folded corner */
        .custom-file-icon::after {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          width: 12px;
          height: 12px;

          background: rgba(255, 255, 255, 0.35);

          /* THIS makes the curved shape */
          border-bottom-left-radius: 22px;

          /* optional shadow for depth */
          box-shadow: -2px 2px 4px rgba(0, 0, 0, 0.15);
        }

        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 4px;
        }
      }

      .file-info-text {
        display: flex;
        flex-direction: column;
        gap: 4px;
        width: 100%;

        .file-name-wrapper {
          display: flex;
          align-items: center;
          gap: 8px;

          .dot {
            width: 3px;
            height: 3px;
            aspect-ratio: 1/1;
            background: #ededed;
          }

          .file-size {
            overflow: hidden;
            color: var(--Neutral-40);
            text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: -0.014px;
          }

          .file-name {
            color: var(--Neutral-100);
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            letter-spacing: -0.14px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: auto;
            max-width: 200px;
          }
        }

        .file-status {
          display: flex;
          align-items: center;
          gap: 4px;
          color: var(--Success-100);
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: -0.12px;
          height: 24px;

          .file-loader {
            flex-direction: row;
          }

          svg {
            width: 16px;
            height: 16px;
          }
        }

        .file-status.loading {
          color: var(--Neutral-100);
        }
      }
    }

    .delete-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: background 0.2s ease;

      &:hover {
        background: var(--Error-8);
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;
